export default {
    title: "DXC Gear",
    support: "Support",
    dashboard: "Dashboard"
}